import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders,HttpErrorResponse } from '@angular/common/http';
import { Buffer } from 'buffer';
import { BehaviorSubject, Observable, catchError, throwError } from 'rxjs';
import { NotificationService } from './notification.service';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class ApigeeService {

  constructor(
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
    private readonly appConfigService: AppConfigService
  ) {
  }

  token: BehaviorSubject<string> = new BehaviorSubject('');

  tokenApigeeObs() {
    let body = new HttpParams()
      .set('grant_type','client_credentials')
      .set('scope',`${this.appConfigService.config.scope}/ar-interactiveReports/v1`);
    
    let buf = Buffer.from(`${this.appConfigService.config.user}:${this.appConfigService.config.pass}`);
    
    let headers = new HttpHeaders()
      .set('Content-type','application/x-www-form-urlencoded')
      .set('Authorization',`Basic ${buf.toString('base64')}`);

    return this.http.post<any>(
      `${this.appConfigService.config.apigeeDomain}/v2/oauth/token`,
      body,
      {headers: headers}
    )
  }

  get tokenApigee(): Readonly<BehaviorSubject<string>> {
    return this.token;
  }

  getQrPDF(pais: any, 
    document: any, 
    verificationCode: any): Observable<any> {
      
    let body = {
      document: document,
      verificationCode: verificationCode
    }

    return this.http.post<any>(
      `${this.appConfigService.config.apigeeDomain}/ar-interactive-reports/v1/countries/${pais}/reports/qrvalidator`,
      body
    )
    .pipe(
      catchError((error) => this.handleError(error))
    );
  }
  
  handleError(errorResp: HttpErrorResponse){
    let tempErr = errorResp.error?.additionalErrorDetails[0]?.message;
    this.notificationService.openLargeMessage({
      severity: "error",
      message: tempErr ? tempErr : 'Error desconocido.',
      title: "Error",
    });
    return throwError(() => errorResp);
  }
}
